import integrationSubject from './Integration/index';
import lookupSubject from './Lookup/index';

const subjects = {
  integration: integrationSubject,
  lookup: lookupSubject
};

export default subjects;
